
@if (service.editedCommentKey == '') {
  <div class="container">
    Write new comment
    <app-addcomment [organizationKey]="organizationKey" [contentKey]="channelKey" [projectKey]="projectKey" [userDisplayName]="userDisplayName" [channelKey]="channelKey" [userId]="userId" [newComment]="true" [contentType]="contentType" [pathSegments]="pathSegments" [doAddCover]="doAddCover" [userImageURL]="userImageURL" [projectName]="projectName" [embeddingModel]="embeddingModel"></app-addcomment>
  </div>
}
@if (service.editedCommentKey != '') {
  <div class="container">
    Write new comment
    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="showCommentEditor()" matTooltip="Add comment">
      <i class="bi bi-chat-square-dots"></i>
    </button>
  </div>
}
<div class="container scrollable-div">
  @for (comment of comments; track comment) {
    <div class="my-1">
      <app-showcomment [organizationKey]="organizationKey" [projectKey]="projectKey" [channelKey]="channelKey" [userDisplayName]="userDisplayName" [userId]="userId" [authorKey]="comment.userId" [authorName]="comment.userName" [channelName]="channelName" [channelPath]="channelPath" [channelKey]="channelKey" [dateOfCreation]="comment.dateOfCreation" [isDeleted]="comment.isDeleted" [imageURLs]="comment.imageURLS" [formattedDate]="comment.formattedDate" [commentContent]="comment.content" [commentKey]="comment.key" [pathSegments]="[]" [contentType]="contentType" [userImageURL]="comment.userImageURL" [projectName]="projectName" [embeddingModel]="embeddingModel">
      </app-showcomment>
    </div>
  }
</div>